// config.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://skillarea.com/api';

export default API_BASE_URL;
